module.exports = __webpack_public_path__ + "img/signal-animation-s.80a7d3a1.png";